// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"42825a39","1559":"b01d167b","2511":"0d5324f2"}[chunkId] + ".chunk.css";
};